import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import logo from '../../assets/logo3.png';
import carregando from '../../assets/loading.gif';
import CryptoJS from 'crypto-js';
import './login.css';

export default function Login({ history }) {
  const [email, setEmail] = useState('');
  const [pwd, setPwd] = useState('');
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState('password');

  useEffect(() => {
    document.body.className = 'hold-transition login-page';
    if (localStorage.getItem('sgiuserid')) {
      history.push('/painel');
    }
  }, [history]);

  async function handleSubmit(event) {
    setLoading(true);
    event.preventDefault();

    const hashPwd = CryptoJS.SHA3(pwd).toString();
    const dataobj = { email, senha: hashPwd };

    try {
      const res = await api.post('/treinamentos/admauthenticate', dataobj);
      if (res.data.error !== undefined) {
        alert(res.data.error);
        setLoading(false);
        return;
      }
      localStorage.setItem('sgiuseremail', email);
      localStorage.setItem('sgiusernome', res.data.nome);
      localStorage.setItem('sgiuserid', res.data._id);
      localStorage.setItem('sgiadmin', res.data.isAdmin);
      localStorage.setItem('sgimaster', res.data.isMaster);
      localStorage.setItem('sgiempresaid', res.data.idempresa);

      const response = await api.get('/treinamentos/empresa/' + res.data.idempresa);
      const data = await response.data;
      localStorage.setItem('sgiempresanome', data[0].nome);
      setLoading(false);
      history.push('/painel');
    } catch (error) {
      alert(error?.response?.data?.message || error?.message || 'Erro ao entrar. Tente novamente.');
      setLoading(false);
    }
  }

  function togglePwd(e) {
    e.preventDefault();
    setType((t) => (t === 'password' ? 'text' : 'password'));
  }

  return (
    <div className="login-professional">
      <div className="login-professional__brand">
        <div className="login-professional__brand-content">
          <div className="login-professional__badge">
            <i className="fa fa-graduation-cap" aria-hidden="true" />
            Plataforma TreinarSGI
          </div>
          <h2 className="login-professional__title">
            Acesse seus treinamentos e evolua com a sua empresa.
          </h2>
          <p className="login-professional__subtitle">
            Faça login para continuar de onde parou e acompanhar seu progresso nos treinamentos.
          </p>
          <ul className="login-professional__features">
            <li className="login-professional__feature">
              <span className="login-professional__feature-icon">
                <i className="fa fa-play-circle" aria-hidden="true" />
              </span>
              Vídeos e conteúdos sob demanda
            </li>
            <li className="login-professional__feature">
              <span className="login-professional__feature-icon">
                <i className="fa fa-certificate" aria-hidden="true" />
              </span>
              Certificados e acompanhamento de progresso
            </li>
            <li className="login-professional__feature">
              <span className="login-professional__feature-icon">
                <i className="fa fa-mobile" aria-hidden="true" />
              </span>
              Acesso de qualquer lugar, basta conectar na iternet
            </li>
          </ul>
        </div>
      </div>

      <div className="login-professional__form-panel">
        <div className="login-professional__card">
          <div className="login-professional__logo">
            <a href="/login" title="TreinarSGI - Início">
              <img src={logo} width={180} alt="TreinarSGI" />
            </a>
          </div>
          <div className="login-professional__heading">
            <h1>Entrar</h1>
            <p>Use seu e-mail e senha para acessar a plataforma</p>
          </div>

          <form className="login-professional__form" onSubmit={handleSubmit} noValidate>
            <div className="login-professional__field">
              <label htmlFor="email">E-mail</label>
              <div className="login-professional__input-wrap">
                <span className="login-professional__input-icon" aria-hidden="true">
                  <i className="fa fa-envelope" />
                </span>
                <input
                  id="email"
                  type="email"
                  className="login-professional__input login-professional__input--with-icon"
                  placeholder="seuemail@empresa.com.br"
                  value={email}
                  required
                  autoComplete="email"
                  autoFocus
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="login-professional__field">
              <label htmlFor="pwLgin">Senha</label>
              <div className="login-professional__input-wrap login-professional__input-wrap--pwd">
                <span className="login-professional__input-icon" aria-hidden="true">
                  <i className="fa fa-lock" />
                </span>
                <input
                  id="pwLgin"
                  type={type}
                  className="login-professional__input login-professional__input--with-icon"
                  placeholder="Digite sua senha"
                  required
                  value={pwd}
                  autoComplete="current-password"
                  onChange={(e) => setPwd(e.target.value)}
                />
                <button
                  type="button"
                  className="login-professional__toggle-pwd"
                  onClick={togglePwd}
                  title={type === 'password' ? 'Mostrar senha' : 'Ocultar senha'}
                  aria-label={type === 'password' ? 'Mostrar senha' : 'Ocultar senha'}
                >
                  <i className={type === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'} aria-hidden="true" />
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="login-professional__submit"
              disabled={loading}
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>

          {loading && (
            <div className="login-professional__loading" role="status" aria-label="Carregando">
              <img src={carregando} width={32} height={32} alt="" />
            </div>
          )}

          <div className="login-professional__footer">
            <a href="/esquecisenha" className="login-professional__link">
              <i className="fa fa-key" aria-hidden="true" />
              Esqueci minha senha
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
